import React, { useCallback, useEffect, useRef, useState } from "react";
import DataGrid, {
  Column,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Summary,
  TotalItem,
} from "devextreme-react/cjs/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { Card } from "react-bootstrap";
import { getAllDiamondProductInventoryData } from "modules/inward/diamond-product-inventory/services/diamond-product-inventory.service";
import notistack from "modules/core/notistack";
import { HttpStatus } from "modules/core";
import { updateGoldAndDiamondInventoryRecords } from "utils/inward";
import { UpdateInventoryReturnDataIds } from "modules/inward/diamond-product-inventory/model";
import { HasPermission } from "Layout/Permissions/permissionsCache";

const DiamondInventorySNMCC = () => {
  let setSelectedRows: Array<number> = [];
  const dataGridRef = useRef<DataGrid>(null);

  const dataSource = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
      try {
        const { searchValue, skip, take } = loadOptions;
        const parameterList = new URLSearchParams();
        if (typeof skip === 'number') parameterList.append('skip', skip.toString());
        if (typeof take === 'number') parameterList.append('take', take.toString());
        const search = JSON.parse(JSON.stringify(loadOptions));
        for (const [key, value] of Object.entries(search)) {
          parameterList.append(key, JSON.stringify(value));
        }
        if (searchValue) {
          parameterList.append("search", searchValue);
        }
        parameterList.append("MaterialType", "diamond");
        parameterList.append("IsSNMCC", "true");
        parameterList.append("IsReceived", "true");
        const response = await getAllDiamondProductInventoryData(parameterList);
        // return {
        //   data: response?.data || [],
        //   totalCount: response?.data.length || 0,
        // };
        return response;
      } catch (error) {
        console.error("Data loading error:", error);
        return { data: [], totalCount: 0 };
      }
    }
  });


  const handleSelectionChange = (e: any) => {
    setSelectedRows = e.selectedRowsData.map((item: any) => item.id);
  };


  const renderSerialNumber = useCallback((cellData: any) => {
    const rowIndex = cellData.rowIndex + 1 + cellData.component.pageIndex() * cellData.component.pageSize();
    return <span>{rowIndex}</span>;
  }, []);

  const updateDiamondAndGoldInventory = async () => {
    try {
      if (setSelectedRows.length > 0) {
        const model = new UpdateInventoryReturnDataIds();
        model.returnToMayaveProductIdList = setSelectedRows;
        const response = await updateGoldAndDiamondInventoryRecords(model);
        if (response.status === HttpStatus.Success) {
          dataGridRef.current?.instance.clearSelection();
          dataGridRef.current?.instance.refresh();
          notistack.notifyFromApi(response);
        }
      } else {
        notistack.warning("Please Select Product");
      }
    } catch (error) {
      console.error("Failed to fetch inward Data:", error);
    } finally {
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="m-0">Memo Diamond Product Inventory</h5>
              {HasPermission('ProductHeader.Write') && <button onClick={updateDiamondAndGoldInventory} className="submit-btn">
                Return
              </button>
              }
            </Card.Header>
            <Card.Body className="pt-0">
              {HasPermission('ProductHeader.Read') &&
                <DataGrid
                  dataSource={dataSource}
                  remoteOperations={{ groupPaging: true }}
                  columnAutoWidth={true}
                  showRowLines={true}
                  keyExpr="id"
                  ref={dataGridRef}
                  showBorders={true}
                  onSelectionChanged={handleSelectionChange}
                  onCellPrepared={(e) => {
                    if (['data', 'header'].includes(e.rowType)) {
                      e.cellElement.style.textAlign = 'center';
                    }
                  }}

                  onContentReady={(e) => {
                    const hasData = e.component.totalCount() > 0;
                    e.component.option("pager.visible", hasData);
                    e.component.option("paging.visible", hasData);
                  }}
                >
                  <Scrolling
                    mode='standard'
                    useNative={true}
                    scrollByContent={true}
                    scrollByThumb={true}
                  />
                  <Selection
                    mode="multiple"
                  />
                  <Pager

                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 25, 50, 100]}

                    showNavigationButtons={true}
                    displayMode="full"
                    showInfo={true}
                  />
                  <Summary>
                    <TotalItem
                    // column="Sr.No."
                    // summaryType="count"
                    // displayFormat="Total: {0}"
                    />
                  </Summary>
                  <Paging defaultPageSize={10} />
                  <SearchPanel visible width={240} placeholder="Search..." />

                  <Column
                    cssClass="text-center" caption="Sr.No."
                    dataType="number"
                    alignment="center"
                    cellRender={renderSerialNumber}
                  />

                  <Column
                    allowFiltering={true}
                    dataField="storeCode"
                    caption="Store Code"
                    dataType="string"
                    width={150}
                  />

                  <Column
                    allowFiltering={true}
                    dataField="bagNo"
                    caption="BagNo."
                    dataType="string"
                    width={150}
                  />

                  <Column
                    allowFiltering={true}
                    dataField="styleNo"
                    caption="Style Number"
                    dataType="string"
                    width={150}
                  />

                  <Column
                    allowFiltering={true}
                    dataField="categoryName"
                    caption="Category Name"
                    dataType="string"
                    width={150}
                  />

                  <Column
                    allowFiltering={false}
                    dataField="grossWt"
                    caption="Gross Weight"
                    dataType="number"
                    format="#,##0.000"
                    width={150}
                  />
                  <Column
                    allowFiltering={false}
                    dataField="netWt"
                    caption="Net Weight"
                    dataType="number"
                    format="#,##0.000"
                    width={150}
                  />

                  <Column
                    allowFiltering={false}
                    dataField="metalKT"
                    caption="Metal KT"
                    dataType="string"
                    width={150}
                  />

                  <Column
                    allowFiltering={false}
                    dataField="diaQty"
                    caption="Diamond Quality"
                    dataType="string"
                    width={150}
                  />

                  <Column
                    allowFiltering={true}
                    dataField="certificateNo"
                    caption="IGI No."
                    dataType="string"
                    width={150}
                  />

                  <Column
                    allowFiltering={true}
                    dataField="huid"
                    cssClass="text-center"
                    caption="HUID"
                    dataType="string"
                    width={150}
                  />

                  <Column
                    allowFiltering={true}
                    dataField="diaMrp"
                    cssClass="text-center"
                    caption="Diamond Price"
                    format="#,##0.00"
                    dataType="string"
                    width={150}
                  />

                  <Column
                    allowFiltering={true}
                    dataField="colorStonePrice"
                    cssClass="text-center"
                    caption="Color Stone Price"
                    dataType="string"
                    width={150}
                  />


                  <Column
                    dataField="isSRP" caption="Price Type" dataType="boolean" cellRender={({ data }) => (
                      <span>{data?.isSRP ? "SRP" : "MRP"}</span>
                    )} width={150}
                  />




                  <Column
                    allowFiltering={false}
                    dataField="dpPrice"
                    caption="DP"
                    format="#,##0.00"
                    dataType="string"
                    width={150}
                  />

                </DataGrid>
              }
            </Card.Body>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};
export default DiamondInventorySNMCC;
